import {call, put, takeEvery} from "redux-saga/effects";

import {POST_CHECKOUT} from "./actionTypes";

import {postCheckoutFail} from "./actions";

import {postCheckoutUrl} from "../../helpers/fakebackend_helper";

function* onPostCheckout({payload: {plan}}) {
  try {
    const response = yield call(postCheckoutUrl, {'plan': plan});
    window.location.href = response.redirect_url;
  } catch (error) {
    yield put(postCheckoutFail(error.message));
  }
}

function* paymentSaga() {
  yield takeEvery(POST_CHECKOUT, onPostCheckout);
}

export default paymentSaga;
